<section [formGroup]="form" fxLayout="row" class="sen-create-project h-100">
  <section fxLayout="row" fxFlex="1 1 auto" class="sen-body-max-width">
    <section fxLayout="column" fxLayoutAlign="space-between center" fxFlex="1 1 30%">
      <sen-app-zone-map (zoneSelected)="form.get('projectWindloadZone')!.setValue($event);" [AddLatLon]="address"
                        [zoneType]="translate.getLng('WINDZONE')"
                        [selectedZone]="this.form.get('projectWindloadZone')!.value"
                        [zoneLabels]="windZones" [zonePathsArray]="windZonePath" [actionType]="sourceAction">
      </sen-app-zone-map>
      <sen-app-zone-map (zoneSelected)="this.form.get('projectSnowloadZone')!.setValue($event);"
                        [AddLatLon]="address" [zoneType]="translate.getLng('SNOWZONE')" [zoneLabels]="snowZones"
                        [zonePathsArray]="snowZonePath" [selectedZone]="this.form.get('projectSnowloadZone')!.value"
                        [actionType]="sourceAction">
      </sen-app-zone-map>
    </section>
    <agm-map *ngIf="address" #agmMap fxFlex="1 1 70%" class="h-100 w-100" [streetViewControl]="false"
             [disableDoubleClickZoom]="true" [mapTypeId]="'hybrid'" [zoom]="20" [latitude]="address.lat"
             [longitude]="address.lon" [fullscreenControl]="true">
      <agm-marker [latitude]="address.lat" [longitude]="address.lon">
        <agm-info-window [isOpen]="true">
          <strong><span>{{translate.getLng('PROJECT_LOCATION')}}</span><br>
            {{address.full}}, {{address.location}},
            {{address.postalCode}} </strong>
        </agm-info-window>
      </agm-marker>
    </agm-map>
    <agm-map *ngIf="!address" fxFlex="1 1 70%" class="h-100 w-100" [streetViewControl]="false"
             [disableDoubleClickZoom]="true" [mapTypeId]="'hybrid'" [zoom]="global.defaultMapZoom"
             [latitude]="global.defaultLat" [longitude]="global.defaultLon" [fullscreenControl]="true">
      <agm-marker [latitude]="global.defaultLat" [longitude]="global.defaultLon">
        <agm-info-window [isOpen]="true">
          <strong><span>{{translate.getLng('GOOGLE_ADDRESS_HELP')}}</span></strong>
        </agm-info-window>
      </agm-marker>
    </agm-map>
  </section>
  <section fxLayout="column" id="senProjectCreateToolBar" class="sen-tool-bar overflow-hidden sen-light-blue-bg">
    <h2 class="px-3 pt-2">{{translate.getLng('PROJECT')}}</h2>
    <div fxFlex="1 1 auto" fxLayout="column" class="px-3 overflow-hidden">
      <mat-form-field id="senProjectNameField" class="w-100 example-full-width">
        <mat-label>{{translate.getLng('PROJECT_NAME')}}</mat-label>
        <input matInput tabindex="1" autocomplete="off" formControlName="projectName">
      </mat-form-field>
      <sen-app-input-address [parentForm]="form" (terrainHeight)="setTerrainHeight($event)" [reqHeight]="true"
                             (sendAddress)="setAddress($event)" [address]="address"></sen-app-input-address>
      <div class="mt-2 position-relative project-config" style="width: 90%;">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <label fxFlex="1 1 auto" class="mb-0"><img src="{{imagePath.windIcon}}" width="12"> &nbsp;
            <b>{{translate.getLng('WINDZONE')}}</b>
          </label>
          <mat-form-field fxFlex="1 1 20%">
            <mat-select tabindex="3" formControlName="projectWindloadZone" id="windZoneId"
                        (selectionChange)="getWindval($event.value)">
              <mat-option *ngFor="let wZone of windZones" [value]="wZone">
                {{wZone}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span> &nbsp;&nbsp;&nbsp;&nbsp;</span>
          <mat-icon (click)="windZoneInfo(windPopUp)" [autoClose]="'outside'" triggers="manual"
                    #windPopUp="ngbPopover" popoverClass="zonePopup" [ngbPopover]="windInformation" placement="left"
                    class="sen-cursor-pointer">
            info
          </mat-icon>
          <ng-template #windInformation>
            <div *ngIf="windResult">
              {{windResult}}
            </div>
          </ng-template>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <label fxFlex="1 1 auto" class="mb-0"><img src="{{imagePath.snowIcon}}" width="12"> &nbsp;
            <b>{{translate.getLng('SNOWZONE')}}</b>
          </label>
          <mat-form-field fxFlex="1 1 20%">
            <mat-select (selectionChange)="getSnowval($event.value)" tabindex="4" formControlName="projectSnowloadZone">
              <mat-option *ngFor="let sZone of snowZones" [value]="sZone" id="snowZoneId">
                {{sZone}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span> &nbsp;&nbsp;&nbsp;&nbsp;</span>
          <mat-icon (click)="snowZoneInfo(snowPopUp)" [autoClose]="'outside'" triggers="manual"
                    #snowPopUp="ngbPopover" [ngbPopover]="snowInformation" placement="left" class="sen-cursor-pointer">
            info
          </mat-icon>
          <ng-template #snowInformation>
            {{snowResult}}
          </ng-template>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <label fxFlex="1 1 auto" class="mb-0"><img src="{{imagePath.terrainIcon}}" width="12"> &nbsp;
            <b>{{translate.getLng('TERRAIN_CAT')}}</b>
          </label>
          <mat-form-field fxFlex="1 1 20%">
            <mat-select id="terrainZoneId" (selectionChange)="getTerrainval($event.value)" tabindex="5"
                        formControlName="projectTerrain">
              <mat-option
                [disabled]="form.get('projectWindloadZone')!.value == windZones[0] && tCat.value == terrainCat[1].value"
                *ngFor="let tCat of terrainCat" [value]="tCat.value">
                {{tCat.label}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span> &nbsp;&nbsp;&nbsp;&nbsp;</span>
          <mat-icon (click)="terrainZoneInfo(terrainPopUp)" [autoClose]="'outside'" triggers="manual"
                    #terrainPopUp="ngbPopover" [ngbPopover]="terrainInformation" placement="left"
                    class="sen-cursor-pointer">
            info
          </mat-icon>
          <ng-template #terrainInformation style="text-align: right;">
              <div style="margin-left: 20px;">
                {{ translate.getLng('TERRAIN_TYPE_INFO').split("-")[0] }}
              </div>
              <div style="margin-left: 20px;">
                {{ translate.getLng('TERRAIN_TYPE_INFO').split("-")[1] }}
              </div>
            </ng-template>
          </div>
        </div>
        <div fxLayout="row" class="my-2" fxLayoutAlign="center center">
          <label class="text-nowrap font-weight-bold">{{translate.getLng('TERRAIN_HEIGHT')}}</label>
        <mat-form-field class="ml-3" fxFlex="1 1 17%">
          <input tabindex="6" formControlName="projectTerrainHeight" type="number" class="text-right" min="0"
                 matInput>
        </mat-form-field>
        <span>{{translate.getLng('UNIT_M')}}</span>
        <mat-icon (click)="resetZoneValue()" class="sen-active-color sen-cursor-pointer float-right">refresh
        </mat-icon>
      </div>
      <div fxLayout="row" class="my-2" fxLayoutAlign="center center">
        <mat-checkbox tabindex="7" formControlName="projectNorthGermanPlain" class="text-nowrap font-weight-bold">&nbsp;{{translate.getLng('NORTH_GERMAN_PLAIN')}}</mat-checkbox>

      </div>
<!--      <div fxLayout="row" class="my-2" fxLayoutAlign="center center">-->
<!--        <mat-checkbox tabindex="7" [(ngModel)]="isNorthGermanPlain"> {{translate.getLng('NORTH_GERMAN_PLAIN')}}</mat-checkbox>-->
<!--      </div>-->
      <mat-error *ngIf="form.hasError('zoneMismatch')">{{translate.getLng('VALUES_MISMATCH')}}:
        {{translate.getLng('SNOWZONE')}} {{form.get('projectSnowloadZone')!.value}}
        {{translate.getLng('WINDZONE')}}
        {{form.get('projectWindloadZone')!.value}}</mat-error>
    </div>
    <div class="my-2" fxLayout="row" fxLayoutAlign="space-evenly center">
      <button mat-raised-button class="px-5 py-2"
              (click)="cancelProject(MPProjectPath)">{{translate.getLng('CANCEL')}}</button>
      <button (click)="saveProject()" class="px-5 py-2" mat-raised-button
              color="primary">{{translate.getLng('SAVE')}}</button>
    </div>
  </section>
</section>
